import { MainCategoryName } from './MainCategories';
import { SubCategoryName } from './SubCategories';

const mainCategoriesBySubcategories: Record<SubCategoryName, MainCategoryName> = {
    [SubCategoryName.RENT]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.HOUSE_LOAN]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.ENERGY]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.UTILITY_BILLS]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.WASTE_DISPOSAL]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.SEWER_FEES]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.INSURANCE]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.FURNITURE]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.IMPROVEMENTS_AND_FURNITURE]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.CLEANING]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.PET_CARE]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.OTHER_LIVING_AND_ENERGY]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.PROPERTY_INSURANCE]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.PIP_INSURANCE]: MainCategoryName.LIVING_AND_ENERGY,
    [SubCategoryName.FOOD_SHOPPING]: MainCategoryName.FOOD,
    [SubCategoryName.RESTAURANT]: MainCategoryName.FOOD,
    [SubCategoryName.OTHER_FOOD]: MainCategoryName.FOOD,
    [SubCategoryName.DRUGSTORE]: MainCategoryName.HEALTH,
    [SubCategoryName.PHARMACY]: MainCategoryName.HEALTH,
    [SubCategoryName.COSMETICS]: MainCategoryName.HEALTH,
    [SubCategoryName.DOCTORS_HOSPITAL]: MainCategoryName.HEALTH,
    [SubCategoryName.LIFE_HEALTH_INSURANCE]: MainCategoryName.HEALTH,
    [SubCategoryName.OTHER_HEALTH]: MainCategoryName.HEALTH,
    [SubCategoryName.COSMETICS_AND_APPEARANCE]: MainCategoryName.HEALTH,
    [SubCategoryName.LIFE_INSURANCE]: MainCategoryName.HEALTH,
    [SubCategoryName.ACCIDENT_INSURANCE]: MainCategoryName.HEALTH,
    [SubCategoryName.HEALTH_INSURANCE]: MainCategoryName.HEALTH,
    [SubCategoryName.RISK_LIFE_INSURANCE]: MainCategoryName.HEALTH,
    [SubCategoryName.FASHION]: MainCategoryName.CLOTHING,
    [SubCategoryName.SHOES]: MainCategoryName.CLOTHING,
    [SubCategoryName.ACCESSORIES]: MainCategoryName.CLOTHING,
    [SubCategoryName.OTHER_CLOTHING]: MainCategoryName.CLOTHING,
    [SubCategoryName.PHONE_BILLS]: MainCategoryName.COMMUNICATION,
    [SubCategoryName.TELEVISION]: MainCategoryName.COMMUNICATION,
    [SubCategoryName.INTERNET]: MainCategoryName.COMMUNICATION,
    [SubCategoryName.ENTERTAINMENT_ELECTRONICS]: MainCategoryName.COMMUNICATION,
    [SubCategoryName.AMUSEMENT]: MainCategoryName.LEISURE,
    [SubCategoryName.HOBBIES_SPORT]: MainCategoryName.LEISURE,
    [SubCategoryName.HOBBIES_COTTAGE_GARDEN]: MainCategoryName.LEISURE,
    [SubCategoryName.READING]: MainCategoryName.LEISURE,
    [SubCategoryName.TOYS_GAMES]: MainCategoryName.LEISURE,
    [SubCategoryName.TOBACCONIST]: MainCategoryName.LEISURE,
    [SubCategoryName.BETTING]: MainCategoryName.LEISURE,
    [SubCategoryName.OTHER_LEISURE]: MainCategoryName.LEISURE,
    [SubCategoryName.KINDERGARTEN_SCHOOL_UNIVERSITY]: MainCategoryName.EDUCATION,
    [SubCategoryName.BOOKS_SUPPLIES]: MainCategoryName.EDUCATION,
    [SubCategoryName.TUITION]: MainCategoryName.EDUCATION,
    [SubCategoryName.OTHER_EDUCATION]: MainCategoryName.EDUCATION,
    [SubCategoryName.CAR_PURCHASE_LOAN]: MainCategoryName.CAR,
    [SubCategoryName.GAS_FUEL]: MainCategoryName.CAR,
    [SubCategoryName.CAR_MAINTENANCE]: MainCategoryName.CAR,
    [SubCategoryName.CAR_INSURANCE]: MainCategoryName.CAR,
    [SubCategoryName.PARKING]: MainCategoryName.CAR,
    [SubCategoryName.TOLLS]: MainCategoryName.CAR,
    [SubCategoryName.OTHER_CAR]: MainCategoryName.CAR,
    [SubCategoryName.PUBLIC_TRANSPORT]: MainCategoryName.TRANSPORT,
    [SubCategoryName.TAXI]: MainCategoryName.TRANSPORT,
    [SubCategoryName.OTHER_TRANSPORT]: MainCategoryName.TRANSPORT,
    [SubCategoryName.HOLIDAY_ACCOMODATION]: MainCategoryName.TRAVEL_HOLIDAYS,
    [SubCategoryName.HOLIDAY_FOOD_DRINKS]: MainCategoryName.TRAVEL_HOLIDAYS,
    [SubCategoryName.HOLIDAY_EXPENSES]: MainCategoryName.TRAVEL_HOLIDAYS,
    [SubCategoryName.FOREIGN_CURRENCY]: MainCategoryName.TRAVEL_HOLIDAYS,
    [SubCategoryName.OTHER_HOLIDAY]: MainCategoryName.TRAVEL_HOLIDAYS,
    [SubCategoryName.TRAVEL_INSURANCE]: MainCategoryName.TRAVEL_HOLIDAYS,
    [SubCategoryName.ATM_WITHDRAWAL]: MainCategoryName.WITHDRAWAL,
    [SubCategoryName.BRANCH_WITHDRAWAL]: MainCategoryName.WITHDRAWAL,
    [SubCategoryName.CREDIT_CARD_WITHDRAWAL]: MainCategoryName.WITHDRAWAL,
    [SubCategoryName.CREDIT_CARD_BILL]: MainCategoryName.WITHDRAWAL,
    [SubCategoryName.QUICK_CHARGING]: MainCategoryName.WITHDRAWAL,
    [SubCategoryName.OTHER_WITHDRAWAL]: MainCategoryName.WITHDRAWAL,
    [SubCategoryName.CASH_WITHDRAWAL]: MainCategoryName.WITHDRAWAL,
    [SubCategoryName.POCKET_MONEY]: MainCategoryName.ALIMONY_POCKET_MONEY,
    [SubCategoryName.ALIMONEY]: MainCategoryName.ALIMONY_POCKET_MONEY,
    [SubCategoryName.OTHER_ALIMONY_POCKET_MONEY]: MainCategoryName.ALIMONY_POCKET_MONEY,
    [SubCategoryName.PRIVATE_CONTRIBUTION]: MainCategoryName.ALIMONY_POCKET_MONEY,
    [SubCategoryName.UNCATEGORIZED_ONLINE_SHOPPING]: MainCategoryName.ONLINE_SHOPPING,
    [SubCategoryName.AMAZON]: MainCategoryName.ONLINE_SHOPPING,
    [SubCategoryName.GOOGLE]: MainCategoryName.ONLINE_SHOPPING,
    [SubCategoryName.ONLINE_SHOPS]: MainCategoryName.ONLINE_SHOPPING,
    [SubCategoryName.WEB_SERVICES]: MainCategoryName.ONLINE_SHOPPING,
    [SubCategoryName.SAVINGS]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.BUILDING_SOCIETY]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.CAPITALIZATION_PRODUCTS]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.SECURITIES]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.OTHER_SAVINGS]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.CRYPTOCURRENCY]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.INVESTMENTPLAN]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.NOBLE_METAL]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.PENSION_INSURANCE]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.PENSION_INVESTMENT]: MainCategoryName.SAVINGS_INVESTMENT,
    [SubCategoryName.PERSONAL_INCOME_TAX]: MainCategoryName.TAXES,
    [SubCategoryName.VALUE_ADDED_TAX]: MainCategoryName.TAXES,
    [SubCategoryName.OTHER_TAXES]: MainCategoryName.TAXES,
    [SubCategoryName.INTERNAL_TRANSFERS]: MainCategoryName.FEES,
    [SubCategoryName.FEES]: MainCategoryName.FEES,
    [SubCategoryName.INTERESTS]: MainCategoryName.FEES,
    [SubCategoryName.LENDING]: MainCategoryName.FEES,
    [SubCategoryName.OTHER_FEES]: MainCategoryName.FEES,
    [SubCategoryName.EXTERNAL_TRANSFERS]: MainCategoryName.FEES,
    [SubCategoryName.TAXES]: MainCategoryName.FEES,
    [SubCategoryName.FINANCING]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.INSURANCE_PREMIUM]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.UNKNOWN_INSURANCE]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.SOCIAL_INSURANCE]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.GIFTS]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.DONATIONS]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.PENALTIES_GOVERNMENTS]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.OTHER_FINANCING]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.COLLECTION]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.DONATIONS_ASSOCIATION]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.LIABILITY_INSURANCE]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.PAYMENT_PROTECTION_INSURANCE]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.INCOME_PROTECTION_INSURANCE]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.LEGAL_INSURANCE]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.UNCATEGORIZED_EXPENSE]: MainCategoryName.UNCATEGORIZED_EXPENSE,
    [SubCategoryName.SALARY]: MainCategoryName.REGULAR_INCOME,
    [SubCategoryName.PENSION]: MainCategoryName.REGULAR_INCOME,
    [SubCategoryName.BUSINESS_INCOME]: MainCategoryName.REGULAR_INCOME,
    [SubCategoryName.UNEMPLOYMENT_COMPENSATION]: MainCategoryName.REGULAR_INCOME,
    [SubCategoryName.MATERNITY_LEAVE]: MainCategoryName.REGULAR_INCOME,
    [SubCategoryName.FAMILY_ALLOWANCE]: MainCategoryName.REGULAR_INCOME,
    [SubCategoryName.ALIMONY]: MainCategoryName.REGULAR_INCOME,
    [SubCategoryName.OTHER_REGULAR_INCOME]: MainCategoryName.REGULAR_INCOME,
    [SubCategoryName.EXTERNAL_TRANSFERS_INCOMING]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.RENTAL]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.CASH_DEPOSIT]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.OVERTIME_TRAVEL_COMPENSATION]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.INTERNAL_TRANSFER]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.ONLINE_SHOP]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.REIMBURSEMENT]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.SAVINGS_INVESTMENT_INCOME]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.INSURANCE_INCOME]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.OTHER_NON_REGULAR_INCOME]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.CRYPTO_INCOME]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.INVESTMENT_INCOME]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.SAVINGS_INCOME]: MainCategoryName.NON_REGULAR_INCOME,
    [SubCategoryName.UNCATEGORIZED_INCOME]: MainCategoryName.UNCATEGORIZED_INCOME,
    [SubCategoryName.BANK_INFO]: MainCategoryName.UNCATEGORIZED_INCOME,
    [SubCategoryName.PET_INSURANCE]: MainCategoryName.OTHER_EXPENSES,
    [SubCategoryName.DISABILITY_INSURANCE]: MainCategoryName.HEALTH,
    [SubCategoryName.CYBER_INSURANCE]: MainCategoryName.OTHER_EXPENSES,
};

export const getMainCategoryBySubCategory = (
    subCategoryName: SubCategoryName,
): MainCategoryName => {
    return mainCategoriesBySubcategories[subCategoryName];
};

export const getSubCategoriesForMainCategory = (
    mainCategory: MainCategoryName,
): SubCategoryName[] => {
    return Object.values(SubCategoryName).filter(
        (s) => getMainCategoryBySubCategory(s) === mainCategory,
    );
};
